import styled from 'styled-components'
import { textMuted } from '@/theme/colors'
import { text } from '@/theme/typography'

export const NameIntro = styled.p`
	${text.body}
	color: ${textMuted};
	margin: 0 0 20px;
`
